import api from "../../../../api/api";
export const acceptInvitation = (tokenId) => {
    return (dispatch, getState) => {
        return api.acceptInvitation(tokenId);
    };
};
